// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2Yx8s","clinicsSelect":"TableHeading_clinicsSelect__1aJK0"};